export const GET_ADDRESS_FROM_LOC = "GET_ADDRESS_FROM_LOC";
export const GET_ADDRESS_FROM_LOC_RESPONSE = "GET_ADDRESS_FROM_LOC_RESPONSE";
export const LOCATION_ERROR = "LOCATION_ERROR";